<script lang="ts">
import { I3pEventsEnum } from '@nuxtDatakodeUtils/types/I3pEvents.enum'
import MapPanelCommand from '~/components/I3pComponent/MapPanel.vue'
import CommandListPanel from '~/components/I3pComponent/ListPanel.vue'
import CommandTopButtons from '~/components/I3pComponent/TopButtons.vue'
import CommandEntityPanel from '~/components/I3pComponent/EntityPanel.vue'
import { CommandI3pService } from '~/services/commands.i3p.service'
import type { ApplicationService } from '~/services/application.service'

export default {
    name: 'CommandsI3p',
    components: {
        CommandEntityPanel,
        CommandTopButtons,
        CommandListPanel,
        MapPanelCommand,
    },
    props: {
        i3pService: { type: CommandI3pService, required: true },
        baseUrl: { type: String, required: true },
    },
    data() {
        return {
            isAppReady: false,
        }
    },
    computed: {
        applicationService(): ApplicationService {
            return this.$applicationService as ApplicationService
        },
        isApplicationServiceLoading(): boolean {
            return this.applicationService.loading
        },
    },
    watch: {
        applicationService: {
            handler(newAppService: ApplicationService) {
                this.isAppReady = !newAppService.loading
            },
            deep: true,
        },
    },
    async mounted() {
        this.i3pService.emitter
            .on(I3pEventsEnum.entityNotFound, (event: { currentEntityK: string }) => {
                this.$showToaster({ title: `Command ${event.currentEntityK} non trouvée !`, text: '', color: 'danger', icon: 'mdi-alert' })
            })
        await this.i3pService.loadData(!this.$route.params.k)
    },
    methods: {

    },
}
</script>

<template>
    <I3p :i3p-service>
        <template #topButtons>
            <div class="w-100 d-flex pb-2 justify-space-between align-center">
                <CommandTopButtons :base-url="baseUrl" />
            </div>
        </template>
        <template v-if="isAppReady" #map-panel>
            <MapPanelCommand ref="mapPanel" />
        </template>
        <template #list-panel>
            <CommandListPanel :base-url="baseUrl" />
        </template>
        <template #entity-panel>
            <CommandEntityPanel :base-url="baseUrl" />
        </template>
        <template #bottomButtons>
            <I3pPanelsEditButtonsBottom :base-url="baseUrl" />
        </template>
    </I3p>
</template>
